import React from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl } from '../../lib/ep';
import { useCSS } from '../../lib/hooks';

import ButtonCollection from './ButtonCollection';
import { DeleteButton } from './ConfirmButton';

const PairImages = ({ item, ...props }) => {
	const image_format = props?.image_format ?? '1x1';

	if(item.full != undefined) {
		return (
			<div class="img_pair">
				<div class="img_self" style={{ backgroundImage:`url(${item?.full ?? ''})` }}>
					<img src={`${window.cdn_url}img/blank_${image_format}.png`} />
				</div>
			</div>
		)
	}

	return (
		<div class="img_pair">
			<div class="img_self" style={{ backgroundImage:`url(${item[0]?.full ?? ''})` }}>
				<img src={`${window.cdn_url}img/blank_${image_format}.png`} />
			</div>

			<span class="joiner knk-operator" />

			<div class="img_self" style={{ backgroundImage:`url(${item[1]?.full ?? ''})` }}>
				<img src={`${window.cdn_url}img/blank_${image_format}.png`} />
			</div>
		</div>
	)
};

const SimpleUploadedGallery = ({ items, ...props }) => {
	useCSS('comp/simple_uploaded_gallery.css');

	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const min_items = props?.min_items ?? 3;
	const max_items = props?.max_items ?? 8;
	const max_height = props?.max_height ?? '600px';

	const missing_sloths = [];
	if(min_items > items.length) {
		Array(min_items - items.length).fill(0).map((foo) => {
			missing_sloths.push({
				mandatory:true,
			});
		});
	}

	if(max_items !== false) {
		Array(max_items - min_items).fill(0).map((foo) => {
			if((missing_sloths.length + items.length) >= max_items) return;

			missing_sloths.push({
				mandatory:false,
			});
		});
	}

	return (
		<ul class="simple_uploaded_gallery" style={{ maxHeight:max_height }}>
			{items.length > 0 && items.map((item, i) => {
				const is_pair = (item.full != undefined) ? false : true;

				return (
					<li key={`img_${i}`} class="image_slot">
						<div class="img_index" style={{ textAlign:(items.length < 10) ? 'center' : 'end' }}>{i + 1}</div>

						<PairImages
							item={item}
							image_format={props.image_format}
						/>

						<ButtonCollection>
							<DeleteButton
								squared={true}
								onClick={() => props.onDelete((is_pair) ? item[0].image : item.image)}
								_position='left'
							/>
						</ButtonCollection>
					</li>
				)
			})}

			{missing_sloths.map((item, f) => {
				const is_mandatory = item?.mandatory ?? false;

				return (
					<li key={`empty_img_${f}`} class="image_slot is_empty">
						<div class="img_index" style={{ textAlign:(items.length < 10) ? 'center' : 'end' }}>{f + items.length + 1}</div>

						<div class={`img_pair`}>
							<div class={`img_self${(is_mandatory) ? ' ep-exclamation orangeIcon' : ''}`}>[ {i18n((is_mandatory) ? "Mandatory" : "Optional", 'lowercase')} ]</div>
						</div>
					</li>
				)
			})}
		</ul>
	)
};

export default injectIntl(SimpleUploadedGallery);